import * as CardBenefits from '@/src/experiences/card-benefits'

export default CardBenefits.Screens.ReferralBonusOffer
